import React, { useMemo, useCallback, useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios'
import Alert from '@material-ui/lab/Alert'
import Fab from '@material-ui/core/Fab'
import Drawer from '@material-ui/core/Drawer'
import MenuIcon from '@material-ui/icons/Menu'
import { makeStyles } from '@material-ui/core/styles'
import routerSelectors from 'store/selectors/router'
import routerActions from 'store/modules/router'
import Menu from '../components/cauldron/Menu'
import Page from '../components/cauldron/Page'
import {
  getSQLDateFormat,
} from '../utils/date'

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  menu: {
    flexGrow: 0,
    width: '250px',
    minWidth: '250px',
    height: '100%',
    overflowY: 'scroll',
  },
  content: {
    flexGrow: 1,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  fabContainer: {
    position: 'fixed',
    right: '30px',
    top: '10px',
  }
}))

const Cauldron = ({

}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const route = useSelector(routerSelectors.route)

  const [ menuOpen, setMenuOpen ] = useState(false)
  const [ page, setPage ] = useState()
  const [ error, setError ] = useState()

  const adminToken = localStorage.getItem('adminToken')
  const isAdminMode = !!adminToken
  const selectedDate = useMemo(() => {
    if(route.params && route.params.date) {
      return route.params.date
    }
    return getSQLDateFormat(new Date('2024-11-30'))
  }, [
    route.params,
  ])

  const onOpenDate = useCallback((date) => {
    dispatch(routerActions.setQueryParams({
      date,
    }))
    setMenuOpen(false)
  }, [])

  useEffect(() => {
    if(!selectedDate) return
    const doAsync = async () => {
      setError(undefined)
      setPage(undefined)
      const queryParams = {
        date: selectedDate,
      }
      if(adminToken) {
        queryParams.access_token = adminToken
      }
      try {
        const res = await axios.get('/api/v1/date', {
          params: queryParams,
        })
        setPage(res.data)
      } catch(e) {
        let message = e.message
        if(e.response && e.response.data && e.response.data.error) {
          message = e.response.data.error
        }
        setError(message)
      }
    }
    doAsync()
  }, [
    selectedDate,
  ])
  
  return (
    <div className={ classes.root }>
      <div className={ classes.content }>
        {
          error && (
            <Alert severity="error">{ error }</Alert>
          )
        }
        {
          page && (
            <Page
              page={ page }
              date={ selectedDate }
            />
          )
        }
      </div>
      <div className={ classes.fabContainer }>
        <Fab
          size="small"
          color="primary"
          onClick={ () => {
            setMenuOpen(true)
          }}
        >
          <MenuIcon />
        </Fab>
      </div>
      <Drawer anchor="right" open={menuOpen} onClose={() => setMenuOpen(false)}>
        <Menu
          isAdminMode={ isAdminMode }
          selectedDate={ selectedDate }
          onOpenDate={ onOpenDate }
        />
      </Drawer>
    </div>
  )
}

export default Cauldron